import { Input, TextArea } from 'antd-mobile';

import SelectOrganization from './SelectOrganization';
const InputForm = (props) => {
    let { setting = {}, updated, desc, en_name } = props;
    const disabled = updated !== 0;
    if (setting.type === 'textarea') {
        return <TextArea style={{ resize: 'none', '--text-align': 'right' }} placeholder={desc || '请输入'}></TextArea>;
    }

    if (en_name === 'org_id') {
        return SelectOrganization(props);
    }
    return <Input disabled={disabled} placeholder={desc || '请输入'} style={{ '--text-align': 'right' }}></Input>;
};
export default InputForm;
